const ImageModal = ({ selectedImage, onClose }) => {
  if (!selectedImage) return null;

  const handleClose = (e) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <div
      className="modal fade show"
      id="imageModal"
      tabIndex="-1"
      role="dialog"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.8)" }}
      onClick={(e) => {
        if (e.target.id === "imageModal") {
          onClose();
        }
      }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Close"
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="modal-body text-center p-0 m-0">
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="img-fluid"
              style={{
                maxHeight: "80vh",
                width: "100%",
                objectFit: "contain",
                margin: "auto",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
